var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { class: _vm.$style.top }, [
      _c("img", {
        class: _vm.$style.logo,
        attrs: { src: _vm.logo, alt: "directory logo" },
      }),
      _c(
        "div",
        {
          class: {
            [_vm.$style.header]: true,
            [_vm.$style.hover]: !_vm.previewMode,
          },
        },
        [
          !_vm.editing.header
            ? _c("div", { class: _vm.$style.wrapper }, [
                _c("span", { class: _vm.$style.full }, [
                  _vm._v(_vm._s(_vm.header)),
                ]),
                !_vm.previewMode
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        class: _vm.$style.clickable,
                        on: {
                          click: function ($event) {
                            return _vm.toggleEdit("header")
                          },
                        },
                      },
                      [_vm._v("edit")]
                    )
                  : _vm._e(),
              ])
            : _c("text-editor", {
                class: _vm.$style.headerEditorContainer,
                attrs: {
                  name: "header",
                  value: _vm.header,
                  max: "100",
                  classes: _vm.$style.headerEditor,
                  placeholder: "Your hotel directory header text goes here",
                },
                on: {
                  save: _vm.updateHeader,
                  clear: function ($event) {
                    return _vm.toggleEdit("header")
                  },
                },
              }),
        ],
        1
      ),
    ]),
    _vm.canShowSubHeader
      ? _c(
          "div",
          {
            class: {
              [_vm.$style.subheader]: true,
              [_vm.$style.hover]: !_vm.previewMode,
            },
          },
          [
            !_vm.editing.subHeader
              ? _c("div", { class: _vm.$style.subContent }, [
                  _vm.subHeader
                    ? _c("span", { class: _vm.$style.full }, [
                        _vm._v(_vm._s(_vm.subHeader)),
                      ])
                    : _c("span", { class: _vm.$style.fullWithoutContent }, [
                        _vm._v("Your sub header text goes here"),
                      ]),
                  !_vm.previewMode
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          class: _vm.$style.clickable,
                          on: { click: _vm.updateShowSubHeader },
                        },
                        [_vm._v("delete")]
                      )
                    : _vm._e(),
                  !_vm.previewMode
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          class: _vm.$style.clickable,
                          on: {
                            click: function ($event) {
                              return _vm.toggleEdit("subHeader")
                            },
                          },
                        },
                        [_vm._v("edit")]
                      )
                    : _vm._e(),
                ])
              : _c("text-editor", {
                  attrs: {
                    name: "subHeader",
                    value: _vm.subHeader,
                    max: "250",
                    placeholder: "Your sub header text goes here",
                  },
                  on: {
                    save: _vm.updateSubHeader,
                    clear: function ($event) {
                      return _vm.toggleEdit("subHeader")
                    },
                  },
                }),
          ],
          1
        )
      : _vm._e(),
    _vm.canShowWarning
      ? _c(
          "div",
          {
            class: {
              [_vm.$style.warning]: true,
              [_vm.$style.hover]: !_vm.previewMode,
            },
          },
          [
            !_vm.editing.warning
              ? _c("div", { class: _vm.$style.subContent }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("warning"),
                  ]),
                  _vm.warning
                    ? _c("span", { class: _vm.$style.full }, [
                        _vm._v(
                          _vm._s(
                            _vm.warning || "Your warning message goes here"
                          )
                        ),
                      ])
                    : _c("span", { class: _vm.$style.fullWithoutContent }, [
                        _vm._v("Your warning message goes here"),
                      ]),
                  !_vm.previewMode
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          class: _vm.$style.clickable,
                          on: { click: _vm.updateShowWarning },
                        },
                        [_vm._v("delete")]
                      )
                    : _vm._e(),
                  !_vm.previewMode
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          class: _vm.$style.clickable,
                          on: {
                            click: function ($event) {
                              return _vm.toggleEdit("warning")
                            },
                          },
                        },
                        [_vm._v("edit")]
                      )
                    : _vm._e(),
                ])
              : _c(
                  "text-editor",
                  {
                    attrs: {
                      name: "warning",
                      value: _vm.warning,
                      max: "250",
                      classes: _vm.$style.warningEditor,
                      placeholder: "Your warning message goes here",
                    },
                    on: {
                      save: _vm.updateWarning,
                      clear: function ($event) {
                        return _vm.toggleEdit("warning")
                      },
                    },
                  },
                  [
                    _vm.editing.warning
                      ? _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            class: _vm.$style.warningEditorSign,
                            attrs: { slot: "prefix" },
                            slot: "prefix",
                          },
                          [_vm._v("warning")]
                        )
                      : _vm._e(),
                  ]
                ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }